<template>

    <b-col>
    <b-row class="mb-2 mt-3">
            <b-col>
                <div class="OTchiclet" v-for="item in scope" :key="item">
                    <span class="OTchicletLabel">{{ item }}<span class="ot-icon-chiclet"></span></span> 
                </div>
            </b-col>
            <b-col  class="OTfixcenterfromRightSpace text-right" >
                <div class="OTchiclet float-right OTchicletClearDashboard" v-on:click="clearAll" ><span class="OTchicletLabel" title="Clear All">Clear All<span class="ot-icon-chiclet"></span></span></div>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>

export default {

    data() {
        return {
            list:[]
        }
    },

    props:[
        'information'
    ],

    computed: {
        scope() {
            this.list = []

            if(this.$store.state.facets.facetIds.indexOf('LF_ID') >= 0){
                this.$store.state.facets.facetIds.splice(this.$store.state.facets.facetIds.indexOf('LF_ID'), 1);
            }
             
            this.$delete(this.$store.state.facets.facets, 'LF_ID')

            if(this.$store.state.facets.facetIds.indexOf('SF_ID') >= 0){
                this.$store.state.facets.facetIds.splice(this.$store.state.facets.facetIds.indexOf('SF_ID'), 1);
            }
             
            this.$delete(this.$store.state.facets.facets, 'SF_ID')

            if (!this.$store.state.facets.selectedFacets['TF_ID']) {
                this.list.push('Last 7 Days');
            } else {

                var facet = this.$store.state.facets.selectedFacets['TF_ID'][0];

                if (facet === 'LHD_ID') {
                    this.list.push('Last Hour');
                } else if (facet === 'TD_ID') {
                    this.list.push('Last 24 Hours');
                } else if (facet === 'LWD_ID') {
                    this.list.push('Last 7 Days');
                }

                var facet = this.$store.state.facets.selectedFacets['GF_ID'];
                for (var data in facet){
                    this.list.push(this.$store.state.facets.selectedFacets['GF_ID'][data]);
                }
                var facet = this.$store.state.facets.selectedFacets['JF_ID'];
                for (var data in facet){
                    this.list.push(this.$store.state.facets.selectedFacets['JF_ID'][data]);
                }
                return this.list;
            }
        }
    },

    created() {
        this.$eventBus.$emit('clearAllFilters');
    },

    methods: {
        clearAll() {
            this.$eventBus.$emit('clearAllFilters');
        }
    }
}
</script>
